import Svg from '@grebban/react-core-components/svg/Svg';
import Path from '@grebban/react-core-components/svg/Path';
import { type CssColorKey } from 'config/branding/colors';
import { type CssVariable } from 'config/branding/types';

interface Props {
    color?: CssVariable<CssColorKey>;
    height?: string | string[];
    width?: string | string[];
    viewBox?: string | string[];
}

export const PinIcon = ({
    color = 'var(--color-brand-yellow)',
    height = '13px',
    width = '16px',
    viewBox = '0 0 13 16',
    ...rest
}: Props) => (
    <Svg width={width} height={height} viewBox={viewBox} fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="pin2">
            <mask
                id="mask0_11140_49391"
                style={{ maskType: 'luminance' }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="13"
                height="16"
            >
                <path id="Clip 2" fillRule="evenodd" clipRule="evenodd" d="M0 8V0H12.1905V8V16H0V8Z" fill="white" />
            </mask>
            <g mask="url(#mask0_11140_49391)">
                <Path
                    id="Combined Shape"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.19414 6.75676C4.20847 5.54335 4.81259 4.52189 6.35472 4.52189C7.89686 4.52189 8.51531 5.76653 8.51531 6.75676C8.51531 7.747 7.91269 9.02621 6.35472 8.99164C4.95617 8.99164 4.17981 7.97018 4.19414 6.75676ZM1.40234 6.84343C1.40234 7.88343 1.64996 8.9451 2.16584 10.0068C2.5579 10.8301 3.11504 11.6534 3.81663 12.4334C4.99282 13.7553 6.16901 14.5351 6.21028 14.5568C6.25155 14.5784 6.29282 14.6001 6.33409 14.6001C6.37536 14.6001 6.41663 14.5784 6.4579 14.5568C6.49917 14.5351 7.67536 13.7553 8.85155 12.4334C9.55314 11.6534 10.1103 10.8301 10.5023 10.0068C11.0595 8.96676 11.3071 7.9051 11.3071 6.84343C11.3071 3.96176 9.07853 1.6001 6.35472 1.6001C3.63092 1.6001 1.40234 3.96176 1.40234 6.84343Z"
                    fill={color || '#FECB00'}
                />
            </g>
        </g>
    </Svg>
);
